<script lang="ts">
	import { createEventDispatcher } from "svelte";
	import type { FilterStores } from "../../../../types/types.serpPage";

	export let filter: FilterStores;
	let isChecked: boolean = false;
	let length: number = 0;
	const dispatch = createEventDispatcher();

	$: {
		isChecked = filter.currentValueSelected?.length > 0 && filter.currentValueSelected[0] === "true";
		const paramsTrue = filter.currentValues.find((filtr) => filtr.name === "true");
		length = paramsTrue ? paramsTrue.length : 0;
	}

	function valueChanged(e: any) {
		dispatch("valueChanged", {
			value: e.target.value,
			filter: filter,
		});
	}
</script>

{#if filter.currentValues.length > 0}
	<input type="checkbox" name={filter.name} value="true" checked={isChecked} id="filter_{filter.name}" on:change={(e) => valueChanged(e)} />
	<label for="filter_{filter.name}">
		<span>
			{filter.name}
			{#if length > 0}
				<i>({length})</i>
			{/if}
		</span>
	</label>
{/if}
